import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Draggable } from 'react-beautiful-dnd';
import { getUserColor } from '../../utils/function';
import { format } from 'date-fns';
import { UTILS } from '../../constants';
// import 'bootstrap/dist/css/bootstrap.min.css';
import { Tooltip } from 'bootstrap'; // Import Tooltip from Bootstrap
export const NestedCard = ({
  column,
  onPressCard,
  setGetParams,
  handleDelete,
  handleShow,
}) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [getattachemtID, setgetattachemtID] = useState(null);
  const handleShows = (id) => {
    setShow(true);
    setgetattachemtID(id);
  };
  // console.log("umn.cards", column.cards);

  // const getInitials = (name) => {
  //   const nameParts = name.split(' ');
  //   if (nameParts.length === 1) {
  //     return nameParts[0][0].toUpperCase();
  //   } else {
  //     return nameParts.map(part => part[0].toUpperCase()).join('');
  //   }
  // };

  const calculateDaysDifference = (startDateStr, endDateStr) => {
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);
    if (isNaN(startDate) || isNaN(endDate)) {
      throw new Error('Invalid date');
    }
    const msPerDay = 1000 * 60 * 60 * 24;
    const differenceInMs = endDate - startDate;
    // Calculate difference in days
    const daysDifference = Math.floor(differenceInMs / msPerDay);
    return daysDifference;
  };
  const normalizeDate = (date) => {
    const d = new Date(date);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  };
  const dd = new Date();
  const nowdate = new Date(dd.getFullYear(), dd.getMonth(), dd.getDate());

  // const formatDate = (date) => {
  //   const options = { month: 'numeric', day: 'numeric' };
  //   return new Intl.DateTimeFormat('en-US', options).format(date);
  // };
  const formatDate = (date) => format(date, 'MMM d');

  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new Tooltip(tooltipTriggerEl); // Initialize the tooltip using imported Tooltip
    });
  }, []);

  const getInitials = (name) => {
    const nameParts = name.split(' ');
    let initials = '';

    for (let i = 0; i < nameParts.length; i++) {
      initials += nameParts[i][0]?.toUpperCase();
      if (initials?.length >= 2) {
        break;
      }
    }

    return initials;
  };

  let data = column.cards.map((card) => ({
    ...card,
    assigned_users: card.assigned_users.map((user) => ({
      ...user,
      initials: getInitials(user.name),
    })),
  }));

  return (
    <>
      {data.map((card, index) => (
        // console.log(card),
        <Draggable draggableId={card.id.toString()} index={index} key={card.id}>
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              className={`card submenu-card mb-0 board-list-card react-kanban-card ${
                snapshot.isDragging ? 'react-kanban-card--dragging' : ''
              }`}
              // onClick={handleClick}
            >
              <div className="card-body open-card-item">
                <div className="submenu">
                  <div className="submenu_handle main-card-toggle">
                    {/* {getBannerImage && getBannerImage.id === card.id ? (
                <div
                  className="image-container container2 cover-image-main-div"
                  style={{
                    backgroundColor: card.cover_background_color,
                  }}
                >
                  <img
                    className="selected-image modal-cover-image"
                    id="modal-cover-image"
                    src={card.cover_image}
                    alt="Cover Image"
                  />
                </div>
              ) : (
                <div className="image-container container2 cover-image-main-div">
                  <img
                    className={`${
                      card.cover_image == null ? "main_img" : ""
                    } selected-image cover-image`}
                    src={card.cover_image}
                    alt="Selected Image"
                  />
                </div>
              )} */}
                    <div
                      className="image-container container2 cover-image-main-div"
                      style={{
                        backgroundColor: card?.cover_background_color,
                      }}
                      onClick={() => {
                        onPressCard(card);
                        setGetParams(card.id);
                        handleShow();
                      }}
                    >
                      {card?.cover_image_thumbnail ? (
                        <img
                          className={`${
                            card.cover_image_thumbnail == null ? 'main_img' : ''
                          } selected-image cover-image`}
                          // src={
                          //   card?.cover_time_difference == null
                          //     ? UTILS.images_url + card.cover_image_thumbnail
                          //     : card?.cover_time_difference > 10
                          //     ? UTILS.images_url + card.cover_image_thumbnail
                          //     : UTILS.temp_image_url +
                          //       card.cover_image_thumbnail
                          // }
                          src={
                            card?.cover_time_difference == null
                              ? UTILS.images_url +
                                (card?.cover_image_thumbnail?.toLowerCase().endsWith('.gif') ? card.cover_image : card.cover_image_thumbnail)
                              : card?.cover_time_difference > 10
                              ? UTILS.images_url +
                                (card?.cover_image_thumbnail?.toLowerCase().endsWith('.gif') ? card.cover_image : card.cover_image_thumbnail)
                              : UTILS.temp_image_url +
                                (card?.cover_image_thumbnail?.toLowerCase().endsWith('.gif') ? card.cover_image : card.cover_image_thumbnail)
                          }
                          alt="Selected Image"
                        />
                      ) : (
                        ''
                      )}
                    </div>

                    <div class="main-card-edit do-not-target">
                      <button class="main-card-button">
                        <span
                          data-bs-toggle="tooltip"
                          data-placement="bottom"
                          title="Remove Card"
                          class="material-symbols-outlined"
                          onClick={() => handleShows(card.id)}
                          // handleDelete(card.id);
                        >
                          delete
                        </span>
                      </button>
                    </div>
                    <div
                      class="submenu_title"
                      onClick={() => {
                        onPressCard(card);
                        setGetParams(card.id);
                        handleShow();
                      }}
                    >
                      <h4
                        className="lineElipse"
                        data-bs-toggle="tooltip"
                        data-placement="bottom"
                        title={card.title}
                      >
                        {card.title}
                        {UTILS.Env === 'local'
                          ? ` [${card.id}] Pos-${card?.position} `
                          : null}
                      </h4>
                      <div class="drag-detail do-not-target justify">
                        <ul class="us-card-list-detail">
                          {card.due_date !== null &&
                          card.start_date !== null &&
                          card.task_completed === 1 ? (
                            <li
                              data-bs-toggle="tooltip"
                              data-placement="bottom"
                              className="dateLabelList labelGreen"
                              title="This card is completed"
                            >
                              <span className="timeIcon">
                                <span class="material-symbols-outlined">
                                  schedule
                                </span>
                              </span>
                              <span className="dateTask">Completed</span>
                            </li>
                          ) : card.due_date !== null &&
                            card.start_date !== null &&
                            nowdate > normalizeDate(new Date(card.due_date)) ? (
                            <li
                              data-bs-toggle="tooltip"
                              data-placement="bottom"
                              className="dateLabelList labelRed"
                              title="This card is past due date"
                            >
                              <span className="timeIcon">
                                <span class="material-symbols-outlined">
                                  schedule
                                </span>
                              </span>
                              <span className="error dateTask">
                                {formatDate(new Date(card.start_date))} -{' '}
                                {formatDate(new Date(card.due_date))}
                              </span>
                            </li>
                          ) : card.due_date !== null &&
                            card.start_date !== null ? (
                            <li
                              data-bs-toggle="tooltip"
                              data-placement="bottom"
                              className="dateLabelList labelYellow"
                              title="This card is pending"
                            >
                              <span className="timeIcon">
                                <span class="material-symbols-outlined">
                                  schedule
                                </span>
                              </span>
                              <span className="pending">
                                {formatDate(new Date(card.start_date))} -{' '}
                                {formatDate(new Date(card.due_date))}
                              </span>
                            </li>
                          ) : (
                            ''
                          )}
                          {card?.description ? (
                            <li>
                              <a
                                href="javascript:void(0);"
                                data-bs-toggle="tooltip"
                                data-placement="bottom"
                                title="This card has a description."
                                class="ddt_list"
                              >
                                <i class="fas fa-align-justify"></i>
                              </a>
                            </li>
                          ) : (
                            ''
                          )}

                          <li>
                            <a
                              href="javascript:void(0);"
                              class="ddt_list comment-count-div"
                              data-bs-toggle="tooltip"
                              data-placement="bottom"
                              title="Comments"
                            >
                              <i class="far fa-comment"></i>
                              <span class="comment-count">
                                {card?.comments_count}
                              </span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="javascript:void(0);"
                              data-bs-toggle="tooltip"
                              data-placement="bottom"
                              title="Attachments"
                              class="ddt_list attachment-count-div"
                            >
                              <i class="fas fa-paperclip"></i>
                              <span class="attachment-count">
                                {card?.attachments_count}
                              </span>
                            </a>
                          </li>
                        </ul>

                        <ul class="us-card-list-member">
                          {card?.assigned_users?.map((value, id) => {
                            return (
                              <li class="member-card-overlay dropdown">
                                <a
                                  href="javascript:void(0);"
                                  class={
                                    `btn btn-secondary dropdown-toggle color` +
                                    getUserColor(value && value?.name)
                                  }
                                  type="button"
                                  title={value && value?.name}
                                  data-bs-toggle="tooltip"
                                  data-placement="bottom"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >
                                  <p>{value && value?.initials}</p>
                                </a>
                                {/* <div
                                  class="dropdown-menu profile-card member-outer"
                                  aria-labelledby="dropdown"
                                >
                                  <div class="pchead">
                                    <div class="pc-name">
                                      <button class="close-btn-pop">
                                        <span class="material-symbols-outlined">
                                          close
                                        </span>
                                      </button>
                                      <div class="short-name">
                                        <span
                                          class={
                                            'color' +
                                            getUserColor(value && value?.name)
                                          }
                                        >
                                          {value && value?.initials}
                                        </span>
                                      </div>
                                      <div class="short-detail">
                                        <h3>{value && value?.name}</h3>
                                        <h4>{value && value?.name}</h4>
                                      </div>
                                    </div>
                                  </div>
                                  <a
                                    href="javascript:void(0);"
                                    class="view-profile view-pro-out"
                                  >
                                    View Profile
                                  </a>
                                  <div class="pcfoot">
                                    <a
                                      href="javascript:void(0);"
                                      class="view-profile view-pro-out"
                                    >
                                      Remove from card
                                    </a>
                                  </div>
                                </div> */}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Draggable>
      ))}
      <div className="addCard"></div>
      <Modal className="deleteModal" show={show} onHide={handleClose}>
        <Modal.Header>
          <div className="modalHead">
            <span class="material-symbols-outlined">warning</span>
            {/* <h4>Are You Sure ?</h4> */}
          </div>
        </Modal.Header>
        <Modal.Body>
          <Modal.Title>Are you sure you want to delete this Card.</Modal.Title>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              handleDelete(getattachemtID);
              handleClose();
            }}
            style={{ backgroundColor: 'red', color: 'white', border: 'none' }}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

// export default NestedCard;
